import { GenericApiResponse } from '@type/general';
import restApi from '@services/api';

import {
  GeneratePreSignedURLPayload,
  GeneratePreSignedURLResponse,
  UploadFilePayload
} from './types';

const FileApis = restApi.injectEndpoints({
  endpoints: builder => ({
    generatePreSignedURL: builder.mutation<
      GenericApiResponse<GeneratePreSignedURLResponse>,
      GeneratePreSignedURLPayload
    >({
      query: payload => ({
        url: `${process.env.REACT_APP_BASE_API_VERSION}/support/utils/get-upload-signed-url/${payload.url}`,
        method: 'POST',
        body: payload.body
      })
    }),
    uploadFileToS3: builder.mutation<void, UploadFilePayload>({
      query: ({ url, payload, contentType }) => ({
        url: url,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': contentType
        },
        credentials: 'omit'
      })
    })
  })
});

export const { useGeneratePreSignedURLMutation, useUploadFileToS3Mutation } =
  FileApis;
